/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/behavior/base';

import ShapeEnum from 'shared/enum/shape';
import SelectTypeEnum from 'shared/enum/select.type';
import BuildingEnum from 'galax/enum/building';


export default class extends Base
{
  canNavigate ()
  {
    return false;
  }


  canSelect ()
  {
    return this.args.type === BuildingEnum.Gate;
  }


  getSelectType ()
  {
    if (this.args.type === BuildingEnum.Gate)
    {
      return SelectTypeEnum.Galaxy;
    }

    return SelectTypeEnum.Zone;
  }


  getSelectShape (source, galaxy)
  {
    if (this.args.type === BuildingEnum.Gate)
    {
      return ShapeEnum.QuadrupleArea;
    }

    return super.getSelectShape(source, galaxy);
  }


  isPaneCollapsed ()
  {
    return false;
  }


};

